// Gallery content for /gallery/images and /gallery/videos.
//
// IMAGES — 12 service-specific before/after pairs (24 photographs total).
// Each pair was generated via Gemini Nano Banana (gemini-3.1-flash-image-preview)
// with prompts that fix the EXACT same camera angle, scene, lighting and
// surroundings, so the before↔after transition is realistic and trustworthy.
// Files live on the backend at /app/backend/uploads/gallery/ and are served by
// the /api/uploads static mount.

const API = process.env.REACT_APP_BACKEND_URL;
const u = (id) => `${API}/api/uploads/gallery/${id}.png`;

export const GALLERY_FILTERS = [
  { id: 'all', label: 'All Results' },
  { id: 'termite', label: 'Termite' },
  { id: 'cockroach', label: 'Cockroach' },
  { id: 'bedbug', label: 'Bed Bugs' },
  { id: 'rodent', label: 'Rodent' },
  { id: 'mosquito', label: 'Mosquito' },
  { id: 'general', label: 'Home & Commercial' },
];

// 12 before/after pairs covering all major services.
export const BEFORE_AFTER = [
  {
    id: 'ba-01',
    service: 'termite',
    title: 'Termite-Damaged Wooden Door Restored',
    description: 'Severe termite infestation in a 12-year-old hardwood door — mud tubes, frass and wing piles fully treated, surface sealed and re-polished by EntoRid technicians.',
    location: 'Dehradun · Apartment',
  },
  {
    id: 'ba-02',
    service: 'termite',
    title: 'Termite-Infested Wooden Furniture Restored',
    description: 'Traditional wooden cupboard with active termite tunnels and frass — drill-and-inject treatment + polish, 5-year termite-proof warranty.',
    location: 'Haridwar · Independent House',
  },
  {
    id: 'ba-03',
    service: 'cockroach',
    title: 'Kitchen Cabinet Cockroach Infestation Cleared',
    description: 'Heavy German-cockroach activity under the sink cabinet — odourless gel baiting + IPM-grade residual spray, follow-up at 14 days.',
    location: 'Rishikesh · Restaurant Kitchen',
  },
  {
    id: 'ba-04',
    service: 'cockroach',
    title: 'Restaurant Kitchen Fully Sanitised',
    description: 'Commercial restaurant kitchen with grease & cockroach harborage at drains and hood — IPM gel + perimeter spray + sanitation audit. FSSAI-ready report delivered.',
    location: 'Roorkee · Cafeteria',
  },
  {
    id: 'ba-05',
    service: 'bedbug',
    title: 'Bed Bug Treatment on Master Bedroom Mattress',
    description: 'Bed-bug live insects and fecal spots along the mattress seam — heat + chemical combo treatment, 100% elimination confirmed at 30-day follow-up.',
    location: 'Dehradun · Hotel Room',
  },
  {
    id: 'ba-06',
    service: 'bedbug',
    title: 'Full Bedroom Bed Bug Disinfestation',
    description: 'Visible bed-bug activity at headboard joint and wall — complete deep-clean + chemical treatment, room re-inspected after 21 days.',
    location: 'Haridwar · Student Hostel',
  },
  {
    id: 'ba-07',
    service: 'rodent',
    title: 'Store-Room Rodent Eviction',
    description: 'Gnawed boxes, droppings and entry hole near the skirting — trap stations, bait grids and entry-point sealing. Activity dropped 95% in 14 days.',
    location: 'Roorkee · Grain Warehouse',
  },
  {
    id: 'ba-08',
    service: 'rodent',
    title: 'Kitchen Rat-Proofing & Sanitisation',
    description: 'Rat droppings and gnawed atta drum — full pantry overhaul with steel-mesh sealing, tamper-proof bait stations and corner caulking.',
    location: 'Mussoorie · Fine-Dine Restaurant',
  },
  {
    id: 'ba-09',
    service: 'mosquito',
    title: 'Society Water-Tank Mosquito Breeding Treated',
    description: 'Stagnant water in a society tank breeding Aedes larvae — larvicidal granules + mesh-cover retrofit. Larvae count zero at next inspection.',
    location: 'Dehradun · Housing Society',
  },
  {
    id: 'ba-10',
    service: 'mosquito',
    title: 'Outdoor Garden Mosquito Fogging',
    description: 'Heavy mosquito activity in society garden — twice-weekly larvicidal + thermal fogging programme, residents report 90% drop in activity.',
    location: 'Haridwar · Apartment Block',
  },
  {
    id: 'ba-11',
    service: 'general',
    title: 'Full Home Multi-Pest Sanitisation',
    description: 'Living room with cockroaches, ants and cobwebs — IPM-grade combo treatment, every corner sealed and sanitised. Comes with 1-year service plan.',
    location: 'Vikasnagar · 3 BHK Home',
  },
  {
    id: 'ba-12',
    service: 'general',
    title: 'Commercial Property Pest Audit & Treatment',
    description: 'Office reception with mixed pest issues — chemical + non-chemical IPM programme, complete audit trail with photos and lab reports.',
    location: 'Rishikesh · Commercial Office',
  },
].map((item) => ({
  ...item,
  beforeUrl: u(`${item.id}-before`),
  beforeUrlSmall: u(`${item.id}-before`),
  afterUrl: u(`${item.id}-after`),
  afterUrlSmall: u(`${item.id}-after`),
}));

// Video gallery — reuses existing testimonial pattern + adds 2 process videos.
export const GALLERY_VIDEOS = [
  {
    id: 'v-termite-01',
    service: 'termite',
    title: 'Real Anti-Termite Drill & Inject Treatment',
    description: 'Behind-the-scenes of a complete post-construction anti-termite treatment by our certified technicians — drill-grid + chemical barrier, exactly as performed on-site.',
    duration: '1:44',
    // Self-hosted H.264 transcode (original IMG_8904 was 57 MB raw — re-encoded to 7.4 MB for fast mobile playback)
    mp4Url: `${API}/api/uploads/gallery-videos/termite-drill-inject-h264.mp4`,
  },
];

export const GALLERY_STATS = {
  treatments: '10,000+',
  satisfaction: '99.4%',
  cities: '24',
  experience: '15+',
};
